"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePurchaseTerms = void 0;
var React = _interopRequireWildcard(require("react"));
var _context = require("../context");
var _fetchExtraPrices = require("../../../services/fetchExtraPrices/fetchExtraPrices");
var _trackModalShow = require("../tracking/trackModalShow");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const usePurchaseTerms = _ref => {
  let {
    offerId,
    mainPromoId,
    isDiscountPromo,
    isBankMortgagePromo
  } = _ref;
  const {
    logger,
    httpApi
  } = React.useContext(_context.PurchaseTermsModalContext);
  const [error, setError] = React.useState(false);
  const [details, setDetails] = React.useState();
  const fetchDetails = React.useCallback(async () => {
    try {
      setError(false);
      const response = await (0, _fetchExtraPrices.fetchExtraPrices)({
        httpApi,
        offerId
      });
      setDetails(response);
      (0, _trackModalShow.trackModalShow)({
        details: response.details,
        mainPromoId,
        isDiscountPromo,
        isBankMortgagePromo
      });
    } catch (error) {
      logger.error(error);
      setError(true);
    }
  }, [logger, httpApi, offerId]);
  return React.useMemo(() => ({
    error,
    details,
    fetchDetails
  }), [error, details, fetchDetails]);
};
exports.usePurchaseTerms = usePurchaseTerms;